import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PlansContainer } from './style';
import { compose } from 'recompose';
import { getId } from '../../../Utils';
import { Plans } from './Plans';
import { Loading } from '../WithLoading/Loading';
import { EmptyState } from '../WithEmptyState/EmptyState';
import { BannerEmptyStatsActivity } from '../../Components/BannerEmptyStats/BannerEmptyStats';
import { EmptyWorkoutCard } from './WorkoutCard';
import { HoverableLink } from '../../Layouts';
import { WorkoutActionCreators } from '../../../Store/ActionCreators/WorkoutsActionCreators';
import ProfilePageWrapper from '../../Components/ProfilePageWrapper';
import TopMenu from '../../Components/TopMenu';
import { ProfileActionCreators } from '../../../Store/ActionCreators/ProfileActionCreators';

class PlannedWorkouts extends Component {
    componentDidMount() {
        const { getPlannedWorkouts, getCurrentProfile, match } = this.props;
        const CURRENT_USER_ID = getId(match.params.profileId);

        getPlannedWorkouts();
        getCurrentProfile(CURRENT_USER_ID);
    }
    // TODO: MOVE PROFILE PAGE WRAPPER TO A SEPARATE COMPONENT
    render() {
        const { plannedWorkouts, plannedWorkoutsLoading, currentUser } = this.props;
        return (
            <div>
                <TopMenu />
                <div style={{ width: '100%', paddingTop: '45px' }}>
                    <ProfilePageWrapper {...currentUser}>
                        <PlansContainer>
                            <HoverableLink to={`/planner`}>
                                <EmptyWorkoutCard />
                            </HoverableLink>
                            <Loading isLoading={plannedWorkoutsLoading}>
                                <EmptyState isEmpty={!plannedWorkouts.length} emptyState={BannerEmptyStatsActivity}>
                                    <Plans plannedWorkouts={plannedWorkouts} />
                                </EmptyState>
                            </Loading>
                        </PlansContainer>
                    </ProfilePageWrapper>
                </div>
            </div>
        );
    }
}

PlannedWorkouts.defaultProps = {
    originalImage: '',
};

const mapStateToProps = ({
    workout: {
        plannedWorkouts,
        statuses: { plannedWorkoutsLoading },
    },
    user: { currentUser },
}) => ({
    plannedWorkouts,
    plannedWorkoutsLoading,
    currentUser,
});

const mapDispatchToProps = (dispatch, props) => {
    return {
        getCurrentProfile: profileId => dispatch(ProfileActionCreators.getUserProfileRequest(profileId)),
        getPlannedWorkouts: () => dispatch(WorkoutActionCreators.getPlannedWorkoutsRequest()),
    };
};

export const PlannedWorkoutsPage = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withRouter,
)(PlannedWorkouts);



// WEBPACK FOOTER //
// ./src/UI/Containers/PlannedWorkouts/index.js